import type { ReleasePr } from "../api/releases";

// Never carry approval/check evidence across different heads or PR states.
export function mergeSearchPrs(...sources: ReleasePr[][]): ReleasePr[] {
  const rows = new Map<string, ReleasePr>();
  for (const incoming of sources.flat()) {
    const key = `${incoming.repo}#${incoming.number}`, old = rows.get(key);
    if (!old) {
      rows.set(key, incoming);
      continue;
    }
    const same = old.head_sha === incoming.head_sha &&
      old.state === incoming.state;
    if (same) {
      rows.set(
        key,
        incoming.identity_only && !old.identity_only
          ? { ...incoming, ...old, identity_only: old.identity_only }
          : { ...old, ...incoming },
      );
      continue;
    }
    const oldTime = Date.parse(old.gh_updated_at ?? ""),
      nextTime = Date.parse(incoming.gh_updated_at ?? "");
    if (
      Number.isFinite(oldTime) && Number.isFinite(nextTime) &&
      nextTime < oldTime
    ) continue;
    rows.set(key, incoming);
  }
  return [...rows.values()];
}
